import { useEffect, useRef, type RefObject } from "react";

// Mirrors a value into a ref so a long-lived effect (interval, subscription)
// can read the latest callback without taking a dep on it — avoids tearing
// down and re-establishing the effect on every parent render.
export function useLatest<T>(value: T): RefObject<T> {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
